import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useCallback, useState } from 'react';

const endpoint = '/ums/v1/cms/document-vault/restaurants';

export function useDocumentPreview() {
  const toast = useCustomToast();
  const [loadingId, setLoadingId] = useState<string | null>(null);

  const previewCurrentDocument = useCallback(
    async (restaurantId: string, documentId: string) => {
      const key = `current-${documentId}`;
      setLoadingId(key);
      try {
        const { data } = await http.get(`${endpoint}/${restaurantId}/${documentId}/preview-url`);
        const previewUrl = data?.data?.previewUrl ?? data?.previewUrl;
        if (previewUrl) {
          window.open(previewUrl, '_blank');
        }
      } catch (error: any) {
        const message = error.response?.data?.message ?? 'Failed to load preview';
        toast({ description: message, status: 'error' });
      } finally {
        setLoadingId(null);
      }
    },
    [toast]
  );

  const previewVersion = useCallback(
    async (restaurantId: string, documentId: string, versionId: string) => {
      const key = `version-${versionId}`;
      setLoadingId(key);
      try {
        const { data } = await http.get(
          `${endpoint}/${restaurantId}/${documentId}/versions/${versionId}/preview-url`
        );
        const previewUrl = data?.data?.previewUrl ?? data?.previewUrl;
        if (previewUrl) {
          window.open(previewUrl, '_blank');
        }
      } catch (error: any) {
        const message = error.response?.data?.message ?? 'Failed to load preview';
        toast({ description: message, status: 'error' });
      } finally {
        setLoadingId(null);
      }
    },
    [toast]
  );

  return { previewCurrentDocument, previewVersion, loadingId };
}
